/**
 * Lista canónica de tipos de proyecto, compartida entre Proyectos y Referencias.
 * Última actualización: 2026-06-03 (sesión 35) — usuario pidió categorías "largo / corto"
 * para diferenciar formato + nueva opción "+ Añadir tipo" libre.
 */

export const PROJECT_TYPES = [
  "Largo Documental",
  "Corto Documental",
  "Largo Ficción",
  "Corto Ficción",
  "Largo Animación",
  "Corto Animación",
  "Serie Ficción",
  "Docuserie",
  "Programa TV",
];

/** Tipos que admiten desglose por episodios (campo `episodes`). */
export const SERIES_TYPES = new Set(["Serie Ficción", "Docuserie", "Programa TV"]);

/** Etiqueta literal usada en el dropdown para añadir un valor libre. */
export const ADD_CUSTOM_TYPE_OPTION = "+ Añadir tipo…";

/**
 * Devuelve las opciones a mostrar en un <select>:
 *  - Lista canónica
 *  - + Cualquier valor actual no canónico (para no perderlo si está en BD)
 *  - + Opción "+ Añadir tipo…"
 */
export function buildTypeOptions(currentValue) {
  const opts = [...PROJECT_TYPES];
  if (currentValue && !opts.includes(currentValue) && currentValue !== ADD_CUSTOM_TYPE_OPTION) {
    opts.push(currentValue);
  }
  opts.push(ADD_CUSTOM_TYPE_OPTION);
  return opts;
}

/**
 * Handler estándar para selectores con opción "+ Añadir tipo…".
 * Si el usuario elige la opción especial, pedimos prompt con un tipo nuevo.
 * Devuelve el valor a guardar (o null si canceló).
 */
export function resolveTypeChoice(chosen) {
  if (chosen !== ADD_CUSTOM_TYPE_OPTION) return chosen;
  const custom = window.prompt(
    "Nombre del nuevo tipo de proyecto:",
    ""
  );
  if (!custom || !custom.trim()) return null;
  return custom.trim();
}
